var _defs, _rect, _g, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatgptLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#6366F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#A855F7"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "glow",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#020617"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#glow)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 80c-97 0-176 64-176 144 0 45 24 85 64 111v73l73-40c12 2 25 3 39 3 97 0 176-64 176-144S353 80 256 80z",
    fill: "none",
    stroke: "url(#grad)",
    strokeWidth: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "url(#grad)",
    strokeWidth: 10,
    fill: "none",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 160c-30 0-55 25-55 55s25 55 55 55 55-25 55-55-25-55-55-55z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 160l40 23v46l-40 23-40-23v-46z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 380,
    cy: 140,
    r: 6,
    fill: "#A855F7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 410,
    cy: 180,
    r: 4,
    fill: "#00E6FF"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: 460,
    textAnchor: "middle",
    fontSize: 18,
    fill: "#94A3B8",
    letterSpacing: 2
  }, "\n    PERSONAL AI ASSISTANT\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatgptLogo);
export default __webpack_public_path__ + "static/media/chatgptLogo.6d208a10ed36eeb8bb07fcdd94777828.svg";
export { ForwardRef as ReactComponent };